module.exports = __webpack_public_path__ + "img/ferrum.11fc2f8d.png";